// Google Authenticator binding page translations
export default {
  title: "Google Authenticator Binding",
  description:
    "For your account security, please bind Google Authenticator before logging in",

  // WeChat Mini Program binding method
  wechatMethod: {
    title: "1. WeChat Mini Program Binding",
    step1:
      'Step 1: Search for "Tencent Authenticator" or "NingDun Token" on WeChat to enter the mini program',
    step2:
      "Step 2: Open the mini program to scan the Google verification QR code above or manually enter the Google verification activation code for binding",
    step3:
      "Step 3: Please enter the dynamic number from the mini program into the input box below for binding",
    qrTitle: "Google Verification QR Code Scan Binding",
    tokenTitle:
      "Google Verification Activation Code Token (Manual input binding in mini program)",
  },

  // Mobile App binding method
  appMethod: {
    title:
      "2. Download and install NingDun Token (iOS and Android users) or Google Authenticator binding (iOS users only)",
    step1:
      "Step 1: Search for the corresponding app in the App Store or Android app market and download it",
    step2:
      "Step 2: Open Google Authenticator, scan the Google verification QR code above or manually enter the Google verification activation code for binding",
    step3:
      "Step 3: Please enter the dynamic number from the authenticator into the input box below for binding",
    qrTitle: "Google Verification QR Code:",
    tokenTitle: "Google Verification Activation Code Token:",
  },

  // Verification code input
  verification: {
    title: "Verification Code",
    placeholder: "Please enter dynamic verification code",
    confirm: "Confirm",
    timeExpired:
      "Verification time is too long, please refresh the page and log in again!",
  },
};
